var map = {
	"./lti.enableScrollEvents.js": [
		4076,
		4076
	],
	"./lti.fetchWindowSize.js": [
		2098,
		2098
	],
	"./lti.frameResize.js": [
		91442,
		91442
	],
	"./lti.hideRightSideWrapper.js": [
		60634,
		60634
	],
	"./lti.removeUnloadMessage.js": [
		25823,
		25823
	],
	"./lti.resourceImported.js": [
		33908,
		33908
	],
	"./lti.screenReaderAlert.js": [
		49676,
		49676
	],
	"./lti.scrollToTop.js": [
		76855,
		76855
	],
	"./lti.setUnloadMessage.js": [
		34402,
		34402
	],
	"./lti.showAlert.js": [
		77398,
		77398
	],
	"./lti.showModuleNavigation.js": [
		68936,
		68936
	],
	"./org.imsglobal.lti.capabilities.js": [
		14734,
		14734
	],
	"./org.imsglobal.lti.get_data.js": [
		83166,
		83166
	],
	"./org.imsglobal.lti.put_data.js": [
		98037,
		98037
	],
	"./requestFullWindowLaunch.js": [
		67440,
		67440
	],
	"./toggleCourseNavigationMenu.js": [
		86573,
		86573
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 97125;
module.exports = webpackAsyncContext;